import get from 'lodash/get'
import { getAxios } from '../lib/axios'
import { isClient } from './isClient'

export const get_env = title => {
   if (isClient) {
      if (!get(window, '_env_')) {
         const getEnvUrl = `${window.location.origin}/server/api/envs`
         getAxios()({
            url: getEnvUrl,
            method: 'POST',
         }).then(() => {
            window.location.reload()
         })
      }
      const env = get(window, '_env_.' + title, '')
      if (title === 'BASE_BRAND_URL') {
         switch (process.env.NEXT_PUBLIC_MODE) {
            case 'production':
               return window.location.origin
            // full-dev will still give error because now we are using BASE_BRAND_URL
            // as http://localhost:4000 and since we have also replaced express url
            // with BASE_BRAND_URL hence in development it will look for local templates folder
            case 'full-dev':
               return 'http://localhost:4000'
            case 'store-dev':
               const { origin } = new URL(
                  get(window, '_env_.' + 'DATA_HUB_HTTPS', '')
               )
               return origin
            default:
               return window.location.origin
         }
      } else if (title === 'GRAPHQL_HTTP_URL') {
         switch (process.env.NEXT_PUBLIC_MODE) {
            case 'production':
               return `https://${window.location.hostname}${
                  new URL(get(window, '_env_.' + 'DATA_HUB_HTTPS', '')).pathname
               }`
            case 'full-dev':
               return `http://localhost${
                  new URL(get(window, '_env_.' + 'DATA_HUB_HTTPS', '')).pathname
               }`
            case 'store-dev':
               return get(window, '_env_.' + 'DATA_HUB_HTTPS', '')
            default:
               return `https://${window.location.hostname}${
                  new URL(get(window, '_env_.' + 'DATA_HUB_HTTPS', '')).pathname
               }`
         }
      } else if (title === 'GRAPHQL_WS_URL') {
         switch (process.env.NEXT_PUBLIC_MODE) {
            case 'production':
               return `wss://${window.location.hostname}${
                  new URL(get(window, '_env_.' + 'DATA_HUB_HTTPS', '')).pathname
               }`
            case 'full-dev':
               return `ws://localhost${
                  new URL(get(window, '_env_.' + 'DATA_HUB_HTTPS', '')).pathname
               }`
            case 'store-dev':
               return get(window, '_env_.' + 'DATA_HUB_WSS', '')
            default:
               return `wss://${window.location.hostname}${
                  new URL(get(window, '_env_.' + 'DATA_HUB_HTTPS', '')).pathname
               }`
         }
      }
      return env
   }
   return null
}
